module.exports = __webpack_public_path__ + "img/cases01-bg.b3648453.jpg";